//Importo action de logout
import { cerrarSesion } from '../../TopMenu/Actions';
 
//Constantes de status
export const IDLESTATUS_INACTIVE = 'INACTIVE';
export const IDLESTATUS_EXPIRED = 'EXPIRED';
export const IDLE_STATUSES = [IDLESTATUS_INACTIVE, IDLESTATUS_EXPIRED];

/**
 * Setea valores de delay.
 * @param {any} idleStatus
 */
export const idleStatusDelay = idleStatus => (dispatch, getState) => {
    if (idleStatus === IDLESTATUS_INACTIVE)
        return getExpirationTime(getState);

    if (idleStatus === IDLESTATUS_EXPIRED)
        return 60000;
}

/**
 * Se ejecuta al volver de la inactividad
 * @param {any} dispatch
 * @param {any} getState
 */
export const activeStatusAction = (dispatch, getState) => {
    $("#idleUserModal").modal('hide');
}

/**
 * Realiza la acción dependiendo del tiempo de inactividad seteado en las constantes.
 * @param {any} idleStatus
 */
export const idleStatusAction = idleStatus => (dispatch, getState) => {
    //Modal de warning deslogeo.
    if (idleStatus === IDLESTATUS_INACTIVE) {
        $('.modal').modal('hide');
        $("#idleUserModal").modal('toggle');
    }

    //Logout
    if (idleStatus === IDLESTATUS_EXPIRED) {
        $("#idleUserModal").modal('toggle');
        
        console.log('estado de modal de inactividad (metodo 1) - IsShow:', $('#idleUserModal').hasClass('in'));
        console.log('estado de modal de inactividad (metodo 2) - IsShow:', $('#idleUserModal').is(':visible'));

        dispatch(cerrarSesion());
    }
}

/**
 * Obtiene el tiempo de expiración
 * @param {any} getState
 */
const getExpirationTime = (getState) => {
    const time = getState().sesion.expirationTime;

    return (time === null || time === undefined || time <= 1)
        ? 840000 //14 minutos por default
        : (time * 60000) - 60000
}


// WEBPACK FOOTER //
// ./Portico/App/Screens/TimerInactividad/actions/TimerInactividad.js